import React from "react";

/**
 * CustomCheckbox
 * - Accessible (real <input type="checkbox" />)
 * - Keyboard friendly
 * - Tailwind styling
 * - Matches: blue square border + filled inner square when checked
 */
const CustomCheckbox = ({
    checked,
    onChange,
    label,
    id,
    name,
    disabled = false,
    required = false,
    className = "",
}) => {
    const inputId = id || `chk_${name || "field"}_${Math.random().toString(16).slice(2)}`;

    return (
        <label
            htmlFor={inputId}
            className={`inline-flex items-center gap-3 select-none ${
                disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
            } ${className}`}
        >
            {/* Real checkbox (visually hidden) */}
            <input
                id={inputId}
                name={name}
                type="checkbox"
                checked={!!checked}
                disabled={disabled}
                onChange={(e) => onChange?.(e.target.checked, e)}
                className="sr-only"
            />

            {/* Custom UI */}
            <span className="relative shrink-0">
                <span
                    aria-hidden="true"
                    className={[
                        "inline-flex h-6 w-6 items-center justify-center rounded-md",
                        "border-2 border-primary bg-white",
                        "transition-transform",
                        disabled ? "" : "active:scale-[0.98]",
                    ].join(" ")}
                >
                    {/* Inner filled square */}
                    <span
                        className={[
                            "h-3.5 w-3.5 rounded-[3px] bg-primary",
                            "transition-all duration-150",
                            checked ? "scale-100 opacity-100" : "scale-0 opacity-0",
                        ].join(" ")}
                    />
                </span>
                {required && (
                    <span className="absolute -top-1 -right-1 text-red-500 text-xs font-bold leading-none">*</span>
                )}
            </span>

            {label ? <span className="text-sm text-slate-900">{label}</span> : null}
        </label>
    );
};

export default CustomCheckbox;
